/**
 * PERSO: met à jour le bloc « Composition » (blocks/perso-composition.liquid) au changement de variante.
 * Même principe que product-inventory.js d'Horizon : le HTML de la section re-rendue pour la nouvelle
 * variante est fourni par l'événement de sélection ; on y reprend le bloc de même identifiant.
 */
import { StandardEvents } from '@shopify/events';

class PersoComposition extends HTMLElement {
  connectedCallback() {
    this.zone = this.closest('.shopify-section, dialog');
    this.zone?.addEventListener(StandardEvents.productSelect, this.#surSelection);
  }

  disconnectedCallback() {
    this.zone?.removeEventListener(StandardEvents.productSelect, this.#surSelection);
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  #surSelection = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const nouveau = html.querySelector(`perso-composition[data-bloc="${this.dataset.bloc}"]`);
        if (nouveau) this.replaceChildren(...nouveau.childNodes);
      })
      .catch((/** @type {any} */ erreur) => {
        if (erreur?.name !== 'AbortError') console.warn('[perso-composition]', erreur);
      });
  };
}

if (!customElements.get('perso-composition')) {
  customElements.define('perso-composition', PersoComposition);
}
